import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Circular-request-base-request-details',
  templateUrl: './Circular-request-base-request-details.component.html'
})

export class CircularRequestBaseRequestDetailsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
   
  }
}